// extracted by mini-css-extract-plugin
export default {"drawer":"notifications-drawer_drawer__9dddS","headerTitle":"notifications-drawer_headerTitle__fCNvk","headerTitleButton":"notifications-drawer_headerTitleButton__qVPyW"};